import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import "./index.css";
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp'
import serviceIconApps from '../../assets/images/service-icon-apps.webp'
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp'
import serviceIconWebsite from '../../assets/images/service-icon-website.webp'
import serviceIconClients from '../../assets/images/service-icon-clients.webp'

const offerings = [
  { title: "Custom 3D prints", icon: serviceIcon3dPrint, path: "/services/3dprints" },
  { title: "Websites", icon: serviceIconWebsite, path: "/services/websites" },
  { title: "App development", icon: serviceIconApps, path: "/services/appdev" },
  { title: "Tech consulting", icon: serviceIconConsulting, path: "/services/consulting" },
  { title: "Clients and Partners", icon: serviceIconClients, path: "/partners" },
];

const About = () => {
  const navigate = useNavigate();
  const offeringNavigationTimerRef = useRef<number | null>(null);
  const [selectedOffering, setSelectedOffering] = useState<string | null>(null);

  useEffect(() => () => {
    if (offeringNavigationTimerRef.current !== null) {
      window.clearTimeout(offeringNavigationTimerRef.current);
    }
  }, []);

  const handleOfferingClick = (title: string, path: string) => {
    if (offeringNavigationTimerRef.current !== null) {
      return;
    }

    setSelectedOffering(title);
    offeringNavigationTimerRef.current = window.setTimeout(() => {
      offeringNavigationTimerRef.current = null;
      navigate(path);
    }, 1000);
  };

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-copy">
          <div className="about-offerings" aria-label="What Hogcloud offers">
            {offerings.map((offering) => (
              <div
                className={`about-offering ${selectedOffering === offering.title ? 'active' : ''}`}
                key={offering.title}
              >
                <button
                  type="button"
                  className="about-offering-select"
                  aria-pressed={selectedOffering === offering.title}
                  disabled={selectedOffering !== null}
                  onClick={() => handleOfferingClick(offering.title, offering.path)}
                >
                  <img src={offering.icon} alt="" aria-hidden="true" />
                  <span className="about-offering-title">{offering.title}</span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-contact-callout">
        <div className="about-contact-copy">
          <p className="about-kicker">Have an idea?</p>
          <h2>Tell us what you want to make or build.</h2>
          <p>
            Whether you need a custom print, a website, an app, or tech help,
            we would love to hear from you.
          </p>
          <div className="about-action-row">
            <Link to="/contact" className="about-button">
              Contact Us
            </Link>
            <Link to="/pricing" className="about-button about-button-secondary">
              View Pricing
            </Link>
          </div>
        </div>
        <div className="about-story">
          <h1>A Family business</h1>
          <p>
           Are you a local business or creator looking to scale? We provide the modern tools necessary to run your business more efficiently and create memorable customer experiences. Our services are an investment in your success, typically paying for themselves through reduced labor costs and increased revenue.
          </p>

          <p>
            Our work is straightforward: listen to the idea, help shape it, and
            build something that fits.
          </p>

          <div className="legal-note">
            <p>
              Hogcloud, Inc. is a registered Arkansas S-Corporation located in Fayetteville,
              Arkansas. We are not affiliated with, endorsed by, or sponsored by the
              University of Arkansas, the Arkansas Razorbacks, or any of their associated
              organizations. We are simply proud members of the Fayetteville community.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
